var _path, _path2, _path3, _path4, _circle, _g, _circle2, _path5, _path6, _path7, _rect, _circle3, _path8, _path9, _circle4, _circle5, _circle6, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _mask, _g2, _g3, _g4, _g5, _g6, _g7, _path48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopAnimated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ewe9y8UgtV11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2493 1012.41",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1485.99,126h-973.98c-7.74,0-14.74,3.13-19.8,8.2-5.07,5.07-8.2,12.07-8.2,19.8v667.01c0,7.73,3.14,14.73,8.21,19.79c5.07,5.07,12.07,8.2,19.8,8.2h973.99c7.74,0,14.74-3.13,19.8-8.2c5.07-5.07,8.2-12.07,8.2-19.8v-667.01c0-7.73-3.14-14.73-8.21-19.79-5.07-5.07-12.07-8.2-19.8-8.2Z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1438.01,188h-879.02c-3.31,0-6.31,1.34-8.48,3.52-2.17,2.17-3.51,5.17-3.51,8.49v496.99c0,3.31,1.34,6.32,3.51,8.49s5.17,3.52,8.48,3.52h879.01c3.31,0,6.31-1.34,8.48-3.52c2.17-2.17,3.51-5.17,3.51-8.49v-496.99c0-3.31-1.34-6.32-3.51-8.49s-5.17-3.52-8.48-3.52Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.35,849h-147.7l-9.97,129h167.64l-9.97-129Z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1144,1007h-289c-.28,0-.53-.11-.71-.29s-.29-.44-.29-.72v-13.49c0-4,1.62-7.63,4.25-10.25s6.25-4.25,10.26-4.25h261.99c4,0,7.63,1.62,10.26,4.25c2.62,2.62,4.25,6.25,4.25,10.25v13.49c0,.28-.11.53-.29.72-.18.18-.43.29-.71.29Z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 18.5,
    transform: "translate(999.5 784.5)",
    fill: "none",
    stroke: "#111",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 198,
    height: 389,
    rx: 24,
    ry: 24,
    transform: "translate(368 618)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566,662h-198v287.3h198v-287.3Z",
    fill: "#111",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,636h87c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-87c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#111",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.4,966v0c6.3,0,11.4,5.1,11.4,11.4v0c0,6.3-5.1,11.4-11.4,11.4v0c-6.3,0-11.4-5.1-11.4-11.4v0c0-6.3,5.1-11.4,11.4-11.4Z",
    fill: "#111",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ewe9y8UgtV126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ewe9y8UgtV116"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463,779h62c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-62c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,801h42c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-42c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,823h22c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-22c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 15,
    transform: "translate(424 805)",
    fill: "#ff6e00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ewe9y8UgtV121",
    transform: "translate(0 163.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463,779h62c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-62c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,801h42c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-42c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,823h22c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-22c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 15,
    transform: "translate(424 805)",
    fill: "#ff6e00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ewe9y8UgtV126",
    "mask-type": "luminance",
    x: "-150%",
    y: "-150%",
    height: "400%",
    width: "400%"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 330.635783,
    height: 447.205,
    rx: 0,
    ry: 0,
    transform: "matrix(.528963 0 0 0.599278 380.052952 673.5)",
    fill: "#d2dbed",
    strokeWidth: 0
  }))))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 153.5,
    transform: "translate(287.5 653.5)",
    fill: "#009691",
    stroke: "#111",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1940.01,468h-684.02c-7.73,0-14.73,3.13-19.79,8.2s-8.2,12.07-8.2,19.8v441c0,7.73,3.13,14.73,8.2,19.8s12.06,8.2,19.79,8.2h684.02c7.73,0,14.73-3.13,19.79-8.2s8.2-12.07,8.2-19.8v-441c0-7.73-3.13-14.73-8.2-19.8s-12.06-8.2-19.79-8.2Z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2018.01,965h-840.02c-.27,0-.52.11-.7.29s-.29.43-.29.71v20c0,5.8,2.35,11.05,6.15,14.85s9.05,6.15,14.86,6.15h799.99c5.8,0,11.05-2.35,14.85-6.15s6.15-9.05,6.15-14.85v-20c0-.28-.11-.53-.29-.71s-.42-.29-.7-.29Z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1653.29,965.45h-111.98c1.95,5.14,5.22,9.62,9.4,13.03c5.34,4.36,12.16,6.97,19.58,6.97h54.01c7.43,0,14.24-2.61,19.58-6.97c4.18-3.41,7.45-7.89,9.4-13.03Z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 681.41,
    height: 411.85,
    rx: 8,
    ry: 8,
    transform: "translate(1257 511)",
    fill: "#009691"
  })), /*#__PURE__*/React.createElement("g", null, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "translate(977 197)",
    fill: "#293347"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1145,59h-446v435c0,5.53,2.24,10.52,5.86,14.14s8.62,5.86,14.15,5.86h405.98c5.53,0,10.53-2.24,14.15-5.86s5.86-8.62,5.86-14.14v-435Z",
    fill: "#111",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.99,4h-405.98c-5.53,0-10.53,2.24-14.15,5.86s-5.86,8.62-5.86,14.15v27h446v-27.01c0-5.52-2.24-10.52-5.86-14.14s-8.62-5.86-14.15-5.86Z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 9,
    transform: "translate(734 28)",
    fill: "#111"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 9,
    transform: "translate(764 28)",
    fill: "#4f2e80"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 9,
    transform: "translate(794 28)",
    fill: "#009691"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ewe9y8UgtV197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ewe9y8UgtV141"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,343h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,143h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M781,143h27c2.21,0,4,1.79,4,4s-1.79,4-4,4h-27c-2.21,0-4-1.79-4-4s1.79-4,4-4Z",
    fill: "#ff6e00",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M826,143h27c2.21,0,4,1.79,4,4s-1.79,4-4,4h-27c-2.21,0-4-1.79-4-4s1.79-4,4-4Z",
    fill: "#009691",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M871,143h50c2.21,0,4,1.79,4,4s-1.79,4-4,4h-50c-2.21,0-4-1.79-4-4s1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M939,143h74c2.21,0,4,1.79,4,4s-1.79,4-4,4h-74c-2.21,0-4-1.79-4-4s1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,183h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,223h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,263h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,303h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,383h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,423h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M781,183h62c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-62c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M861,183h112c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-112c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#009691",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M991,183h42c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-42c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#ff6e00",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M781,223h42c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-42c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#009691",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M841,223h42c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-42c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#ff6e00",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M901,223h22c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-22c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M781,263h92c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-92c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M891,263h62c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-62c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#ff6e00",
    fillRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M781,303h92c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-92c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M891,303h122c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-122c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#009691",
    fillRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M781,343h62c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-62c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#ff6e00",
    fillRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M861,343h62c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-62c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#009691",
    fillRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M941,343h32c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-32c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M781,383h122c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-122c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M781,423h52c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-52c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#009691",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ewe9y8UgtV169",
    transform: "translate(0 366.5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,343h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,143h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M781,143h27c2.21,0,4,1.79,4,4s-1.79,4-4,4h-27c-2.21,0-4-1.79-4-4s1.79-4,4-4Z",
    fill: "#ff6e00",
    fillRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M826,143h27c2.21,0,4,1.79,4,4s-1.79,4-4,4h-27c-2.21,0-4-1.79-4-4s1.79-4,4-4Z",
    fill: "#009691",
    fillRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M871,143h50c2.21,0,4,1.79,4,4s-1.79,4-4,4h-50c-2.21,0-4-1.79-4-4s1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M939,143h74c2.21,0,4,1.79,4,4s-1.79,4-4,4h-74c-2.21,0-4-1.79-4-4s1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,183h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,223h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,263h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,303h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,383h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "isolate"
    },
    d: "M751,423h10c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-10c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    opacity: 0.54,
    fill: "#535b6b",
    fillRule: "evenodd"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M781,183h62c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-62c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M861,183h112c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-112c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#009691",
    fillRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M991,183h42c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-42c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#ff6e00",
    fillRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M781,223h42c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-42c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#009691",
    fillRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M841,223h42c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-42c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#ff6e00",
    fillRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M901,223h22c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-22c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M781,263h92c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-92c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M891,263h62c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-62c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#ff6e00",
    fillRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M781,303h92c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-92c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M891,303h122c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-122c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#009691",
    fillRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M781,343h62c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-62c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#ff6e00",
    fillRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M861,343h62c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-62c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#009691",
    fillRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M941,343h32c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-32c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M781,383h122c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-122c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#4f2e80",
    fillRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M781,423h52c2.21,0,4,1.79,4,4v0c0,2.21-1.79,4-4,4h-52c-2.21,0-4-1.79-4-4v0c0-2.21,1.79-4,4-4Z",
    fill: "#009691",
    fillRule: "evenodd"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ewe9y8UgtV197",
    "mask-type": "luminance",
    x: "-150%",
    y: "-150%",
    height: "400%",
    width: "400%"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 330.635783,
    height: 447.205,
    rx: 0,
    ry: 0,
    transform: "translate(734.000001 59)",
    fill: "#d2dbed",
    strokeWidth: 0
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2142,365h-548v390c0,7.73,3.13,14.74,8.2,19.8c5.07,5.07,12.07,8.2,19.81,8.2h491.98c7.74,0,14.74-3.13,19.81-8.2s8.2-12.07,8.2-19.8v-390Z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2113.99,315h-491.98c-7.74,0-14.74,3.13-19.81,8.2s-8.2,12.07-8.2,19.8v30.01h548v-30.01c0-7.73-3.14-14.73-8.2-19.8-5.07-5.07-12.07-8.2-19.8-8.2Z",
    fill: "#111",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    r: 9,
    transform: "translate(1637 344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 9,
    transform: "translate(1667 344)",
    fill: "#4f2e80"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 9,
    transform: "translate(1697 344)",
    fill: "#009691"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "ewe9y8UgtV1106",
    d: "M1933,449c56.8,16.88,92,70,93,125s-39.17,109-93,125c-55.39-16-93-69.77-93-125s39.04-108.12,93-125Z",
    fill: "none",
    stroke: "#009691",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1946,437h-24v24h24v-24Z",
    fill: "#fffffe",
    fillRule: "evenodd",
    stroke: "#ff6e00",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1945,687h-24v24h24v-24Z",
    fill: "#fffffe",
    fillRule: "evenodd",
    stroke: "#ff6e00",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1852,563h-24v24h24v-24Z",
    fill: "#fffffe",
    fillRule: "evenodd",
    stroke: "#ff6e00",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2025,
    y1: 484,
    x2: 2025,
    y2: 559,
    fill: "none",
    stroke: "#111",
    strokeWidth: 8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2025,
    y1: 589,
    x2: 2025,
    y2: 664,
    fill: "none",
    stroke: "#111",
    strokeWidth: 8,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "translate(2025 481)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "translate(2025 671)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2037,563h-24v24h24v-24Z",
    fill: "#fffffe",
    fillRule: "evenodd",
    stroke: "#ff6e00",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1934,
    y1: 502.92,
    x2: 1934,
    y2: 645.86,
    fill: "none",
    stroke: "#4f2e80",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1921,
    y1: 528.57,
    x2: 1946,
    y2: 528.57,
    fill: "none",
    stroke: "#4f2e80",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1921,
    y1: 553.05,
    x2: 1946,
    y2: 553.05,
    fill: "none",
    stroke: "#4f2e80",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1921,
    y1: 577.53,
    x2: 1946,
    y2: 577.53,
    fill: "none",
    stroke: "#4f2e80",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1921,
    y1: 602.02,
    x2: 1946,
    y2: 602.02,
    fill: "none",
    stroke: "#4f2e80",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1921,
    y1: 626.5,
    x2: 1946,
    y2: 626.5,
    fill: "none",
    stroke: "#4f2e80",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 12,
    ry: 12,
    transform: "translate(1688 449)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ewe9y8UgtV1123",
    width: 70,
    height: 70,
    rx: 12,
    ry: 12,
    transform: "translate(1688 539)",
    fill: "#009691"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ewe9y8UgtV1124",
    width: 70,
    height: 70,
    rx: 12,
    ry: 12,
    transform: "translate(1688 628)",
    fill: "#4f2e80"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2429,851c-33.14,0-60,26.86-60,60s26.86,60,60,60s60-26.86,60-60-26.86-60-60-60Zm0,95c-19.33,0-35-15.67-35-35s15.67-35,35-35s35,15.67,35,35-15.67,35-35,35Z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430.93,815h-169.93c-1.1,0-2.1.45-2.83,1.17-.72.72-1.17,1.72-1.17,2.83v168c0,5.52,2.24,10.52,5.86,14.14s8.62,5.86,14.14,5.86h137.93c5.52,0,10.52-2.24,14.14-5.86s5.86-8.62,5.86-14.14v-168c0-1.1-.45-2.1-1.17-2.83-.72-.72-1.72-1.17-2.83-1.17Z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2143,952.2c-16.24,0-30.94,6.58-41.58,17.22-9.72,9.72-16.05,22.81-17.07,37.38h117.3c-1.03-14.56-7.36-27.66-17.07-37.38-10.64-10.64-25.34-17.22-41.58-17.22Z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2143,953v0c2.21,0,4,1.79,4,4v5c0,2.21-1.79,4-4,4v0c-2.21,0-4-1.79-4-4v-5c0-2.21,1.79-4,4-4Z",
    fill: "#111",
    fillRule: "evenodd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M305,889h-242c-16.29,0-31.04,6.6-41.72,17.28s-17.28,25.43-17.28,41.72s6.6,31.04,17.28,41.72s25.43,17.28,41.72,17.28h242c1.66,0,3.16-.67,4.24-1.76s1.76-2.59,1.76-4.24v-9.29c0-2.1-.81-4.02-2.15-5.45s-3.19-2.38-5.29-2.53c-13.84-.98-24.13-4.5-31.03-10.21-7.27-6.02-11.04-14.48-11.04-25.53s3.78-19.61,11.13-25.77c6.95-5.82,17.32-9.52,31.32-10.78c2-.24,3.76-1.21,5.02-2.62c1.27-1.42,2.03-3.29,2.03-5.32v-8.51c0-1.66-.67-3.16-1.76-4.24-1.09-1.09-2.59-1.76-4.24-1.76Z",
    fill: "#4f2e80",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.79,912L62,912c-9.94,0-18.94,4.03-25.46,10.54C30.03,929.05,26,938.05,26,948s4.03,18.94,10.54,25.46C43.05,979.97,52.05,984,62,984c108.9,0,186.33.21,232.3.62v0c-8.05-2.17-17.27-5.25-23.83-11.98-5.26-5.41-8.97-13.1-8.97-24.64s3.78-19.37,9.12-24.76c6.13-6.18,14.56-9.2,22.17-11.24Z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#111",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.93,957h202.15c2.17,0,3.93,1.79,3.93,4s-1.76,4-3.93,4h-202.15c-2.17,0-3.93-1.79-3.93-4s1.76-4,3.93-4Z",
    fill: "#111",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.93,931h202.15c2.17,0,3.93,1.79,3.93,4s-1.76,4-3.93,4h-202.15c-2.17,0-3.93-1.79-3.93-4s1.76-4,3.93-4Z",
    fill: "#111",
    fillRule: "evenodd"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M250.15,689.36c-4.91-4.36-9.82-8.73-14.72-13.09-7.82-6.95-15.62-13.91-23.44-20.86-1.79-1.58-3.59-3.18-5.36-4.76v6.3c4.91-4.36,9.82-8.73,14.72-13.09c7.82-6.95,15.62-13.91,23.44-20.86c1.79-1.58,3.59-3.18,5.36-4.76c1.75-1.56,1.73-4.74,0-6.3-1.86-1.71-4.46-1.67-6.34,0-4.91,4.36-9.82,8.73-14.72,13.09-7.82,6.95-15.62,13.91-23.44,20.86-1.79,1.58-3.59,3.18-5.36,4.76-1.73,1.54-1.73,4.76,0,6.3c4.91,4.36,9.82,8.73,14.72,13.09c7.82,6.95,15.62,13.91,23.44,20.86c1.79,1.58,3.59,3.18,5.36,4.76c1.75,1.56,4.64,1.85,6.34,0c1.57-1.69,1.86-4.63,0-6.3v0Z",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.89,618.25c4.91,4.36,9.82,8.73,14.72,13.09c7.82,6.95,15.62,13.91,23.44,20.86c1.79,1.58,3.59,3.18,5.36,4.76v-6.3c-4.91,4.36-9.82,8.73-14.72,13.09-7.82,6.95-15.62,13.91-23.44,20.86-1.79,1.58-3.59,3.18-5.36,4.76-1.75,1.56-1.73,4.74,0,6.3c1.86,1.71,4.46,1.67,6.34,0c4.91-4.36,9.82-8.73,14.72-13.09c7.82-6.95,15.62-13.91,23.44-20.86c1.79-1.58,3.59-3.18,5.36-4.76c1.73-1.54,1.73-4.76,0-6.3-4.91-4.36-9.82-8.73-14.72-13.09-7.82-6.95-15.62-13.91-23.44-20.86-1.79-1.58-3.59-3.18-5.36-4.76-1.75-1.56-4.64-1.85-6.34,0-1.57,1.69-1.86,4.63,0,6.3v0Z",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.54,715.57c1.34-4.01,2.67-8.01,4.01-12.04c3.2-9.64,6.41-19.26,9.61-28.89c3.85-11.62,7.71-23.22,11.59-34.84c3.34-10.04,6.68-20.08,10.02-30.12c1.59-4.88,3.38-9.73,4.86-14.67.02-.07.04-.13.07-.2.74-2.2-.85-4.96-3.14-5.48-2.46-.56-4.73.73-5.51,3.12-1.34,4.01-2.67,8.01-4.01,12.04-3.2,9.64-6.41,19.26-9.61,28.89-3.85,11.62-7.71,23.22-11.59,34.84-3.34,10.04-6.68,20.08-10.02,30.12-1.59,4.85-3.38,9.71-4.86,14.65-.02.07-.04.13-.07.2-.74,2.2.85,4.96,3.14,5.48c2.46.56,4.73-.73,5.51-3.09v0Z",
    fill: "#111"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "787.97,968.67 787.97,1002.99 817.47,1002.99 817.47,990.35 787.97,968.67",
    fill: "#009691"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "714.47,986.07 676.47,989.07 671.47,1003.07 748.47,1002.99 745.47,976.07 714.47,986.07",
    fill: "#009691"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.47,988.07 617.47,989.07 612.47,1003.07 630.47,1002.99 626.47,988.07",
    fill: "#009691"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "752.47,965.07 714.47,986.07 677.47,988.07 658.47,964.07 641.47,963.07 626.47,988.07 612.47,988.07 612.47,958.07 597.47,939.07 643.47,939.07 648.47,958.07 707.47,934.07 707.47,964.07 752.47,965.07",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.11,988.54h33.24c10.13,0,48.07-25.29,48.07-25.29",
    fill: "none",
    stroke: "#111",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.14,1002.99h33.33v-12.64c0-6.65-31.97-27.1-44.61-27.1h-65.35v-28.9c-15.93,0-39.62,20.9-59.15,23.5l.76-6.75c0-8.16-6.62-14.78-14.78-14.78h-33.27c0,8.87-1.63,14.29,11.02,21.51v30.71h14.38",
    fill: "none",
    stroke: "#111",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 25,
    rx: 0,
    ry: 0,
    transform: "translate(709.47 937.07)",
    fill: "#009691"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 666.8,
    y1: 1002.99,
    x2: 752.28,
    y2: 1002.99,
    fill: "none",
    stroke: "#111",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "636.47,1002.99 612.37,1002.99 612.37,988.54",
    fill: "none",
    stroke: "#111",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "706.7,934.35 718.87,934.35 718.87,962.08",
    fill: "none",
    stroke: "#111",
    strokeWidth: 8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 22.58,
    transform: "translate(768.35 985.83)",
    fill: "#111",
    stroke: "#111",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    r: 9.93,
    transform: "translate(768.35 985.83)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 22.58,
    transform: "translate(651.35 985.83)",
    fill: "#111",
    stroke: "#111",
    strokeWidth: 8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    r: 9.93,
    transform: "translate(651.35 985.83)",
    fill: "#a6a6a6"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M2346.5,936.76c-4.55-11.08-13.44-15.96-24.11-18.12-4.42-.9-9.03-.91-13.57-1.13-3.34-.17-6.7-.03-10.26-.03.09-.69.14-1.22.23-1.75.99-5.91-.51-11.05-4.75-15.33-4.23-4.28-9.56-6.69-15.09-8.73-.31-.11-.62-.22-.94-.58.27-.04.55-.1.82-.1c13.49,0,26.98.02,40.47-.03c1.39,0,2.08.28,2.47,1.78c1.67,6.46,5.27,9.17,11.9,9.18c1.88,0,3.76-.05,5.63.02.95.03,1.5-.27,1.74-1.2.58-2.24,1.19-4.47,1.83-6.83.3,1.33.57,2.56.82,3.68h5.49c.23-1.09.49-2.3.75-3.5l.25-.05c.09.48.18.97.29,1.45.27,1.28.47,2.58.84,3.83.75,2.61.79,2.6,3.47,2.6c1.76,0,3.53.02,5.29,0c5.5-.07,9.39-3.06,10.87-8.36q.72-2.57,3.33-2.57c13.26,0,26.53,0,39.79,0c.26,0,.53,0,.79,0c.02.1.04.19.06.29-.81.32-1.63.64-2.44.95-4.12,1.56-8.04,3.47-11.5,6.24-5.74,4.6-8.21,10.45-6.79,17.79.06.33.06.67.1,1.23-.8,0-1.52-.02-2.23,0-6.59.24-13.2.22-19.76.82-5.3.48-10.27,2.46-14.83,5.28-5.03,3.11-8.85,7.25-10.99,13.18Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopAnimated);
export default __webpack_public_path__ + "static/media/desktopAnimated.1f26c9d9bacfd576a2a68520b8a23bf5.svg";
export { ForwardRef as ReactComponent };